import styled from 'styled-components'

const SheetTitle = ({ children }) => {
  return (
    <S_SheetTitle>
      {
        children
      }
    </S_SheetTitle>
  )
}

export default SheetTitle

const S_SheetTitle = styled.h3`
  color: var(--Font_Color);
  width: 100%;
  display: flex;
  justify-content: center;
`